import { render, staticRenderFns } from "./ProfilePhotoStickerComponent.vue?vue&type=template&id=67e575c6&scoped=true&lang=pug"
import script from "./ProfilePhotoStickerComponent.vue?vue&type=script&lang=js"
export * from "./ProfilePhotoStickerComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfilePhotoStickerComponent.vue?vue&type=style&index=0&id=67e575c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e575c6",
  null
  
)

export default component.exports